import media from 'common-ui-components/src/vtj/theme/media'
import { styled } from 'styled-components'
import { Block, Button } from 'suomifi-ui-components'

export const StyledTable = styled.table`
  ${({ theme }) => theme.typography.bodyTextSmall}
  border: 1px solid ${({ theme }) => theme.colors.depthLight1};
  width: 100%;

  th,
  td {
    padding: ${({ theme }) => theme.spacing.m};
    vertical-align: middle;
    ${media.mobileAndTablet} {
      padding: ${({ theme }) => theme.spacing.xs};
    }
  }

  thead {
    tr {
      border-bottom: 2px solid ${({ theme }) => theme.colors.highlightBase};
    }
    th {
      ${({ theme }) => theme.typography.bodySemiBoldSmall}
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid ${({ theme }) => theme.colors.depthLight1};
    }
  }
`

export const FileList = styled.ul`
  li {
    list-style-type: none;
  }
  .fi-icon {
    margin-right: ${({ theme }) => theme.spacing.xs};
    vertical-align: text-top;
  }
`

export const ContentDivider = styled.hr`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.depthLight1};
  margin: ${({ theme }) => theme.spacing.m} 0;
`

export const ModalOrderInfo = styled(Block)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.l};
`

export const ButtonContainer = styled(Block)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .fi-icon {
    margin-right: ${({ theme }) => theme.spacing.xxs};
    vertical-align: text-top;
  }
`

export const MinimalButton = styled(Button)`
  && {
    background: none;
    padding: 0;
    min-height: auto;
    &:hover {
      background: none;
      text-decoration: underline;
    }
  }
`

export const CertificatesMobileList = styled.div`
  width: 100%;
`
export const CertificateMobile = styled.div`
  background-color: ${({ theme }) => theme.colors.depthLight3};
  border-top: 2px solid ${({ theme }) => theme.colors.highlightBase};
  padding: ${({ theme }) => theme.spacing.s};
  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacing.xs};
  }
`

export const DesktopOrMobileContainer = styled.div`
  width: 100%;

  ${StyledTable} {
    display: none;
    ${media.tabletAndDesktop} {
      display: table;
    }
  }

  ${CertificatesMobileList} {
    display: none;
    ${media.mobile} {
      display: block;
    }
  }
`
